<template>
  <v-layout column>
    <v-flex v-for="(q, k, i) in questions" :key="i">
      <h3 :class="radioClasses(k)">{{ q.text }}</h3>
      <v-radio-group :class="radioClasses(k)">
        <v-radio
          color="rgb(135, 0, 0)"
          v-for="(title, idx) in q.options"
          v-on:click.native="$store.commit('updateForm', { key: k, value: title })"
          :key="idx"
          :label="title"
          :value="title"
        ></v-radio>
      </v-radio-group>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'LayoutQuestions',
  props: {
    lang: String,
    questions: Object
  },
  methods: {
    radioClasses(k) {
      if (k === 'voice' || k === 'face') {
        const an = this.$store.state.form.anon
        if (an === 'Yes' || an === 'Ναι') {
          return ''
        } else {
          return 'hidden'
        }
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.hidden {
  display: none;
}
</style>
